import Vue from 'vue';
import Vuex from 'vuex';
import category from './modules/category';
import label from './modules/label';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    category,
    label,
  },
  state: {
    token: '',
    menuList: [],
  },
  mutations: {
    set_token(state, token) {
      state.token = token;
      sessionStorage.token = token;
    },
    set_userType(state, type) {
      state.userType = type;
    },
    del_token(state) {
      state.token = '';
      sessionStorage.removeItem('token');
    },
    updateMenuBtnList(state, menuList) {
      state.menuList = menuList;
    },
  },
  getters: {
    getMenulist: (state) => {
      console.log('state', state);
      return state.menuList;
    },
    getUserType: (state) => {
      return state.userType;
    },
  },
});
